<template>
  <div class="header-extra-component">
    <!-- <h1>Hello</h1> -->
    <vue-placeholder
      v-for="extra in extraSorted"
      :component="extra.component"
      :handler="handler"
      :key="extra['#id']"
    ></vue-placeholder>
  </div>
</template>
<script>
export default {
  props: ["component", "handler"],
  computed: {
    extraSorted() {
      if (!(this.component instanceof Object)) {
        return [];
      }

      return Object.values(this.component).sort((a, b) => {
        return a.weight - b.weight;
      });
    },
  },
};
</script>
<style lang="scss">
.header-extra-component {
  flex: 1 1 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>